<template>
    <ListPage ref="listPage" :query="query" :total="total" v-loading="loading" :data="tableData"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery"
        @selection-change="handleSelectionChange">
        <template slot="filters">
            <el-form-item label="" prop="search_keyword">
                <el-input v-model="query.search_keyword" placeholder="输入推广代理员进行检索" clearable
                    @keyup.enter.native="handleSearch" />
            </el-form-item>
            <el-form-item label="拉新时间" prop="date">
                <el-date-picker v-model="query.date" type="daterange" align="left" unlink-panels range-separator="-"
                    value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
        </template>
        <template slot="btns" v-if="permission('tggl_tglb_dc')">
            <el-button size="mini" type="primary" @click="handleExport"> 导出 </el-button>
        </template>
        <template slot="columns">
            <el-table-column type="selection" width="50" align="center"></el-table-column>
            <el-table-column label="用户名" align="center" prop="nick_name" />
            <el-table-column label="注册手机号码" align="center" prop="mobile" />
            <el-table-column label="注册邮箱" align="center" prop="email" />
            <el-table-column label="推广代理员" align="center" prop="parent_name" />
            <el-table-column label="拉新时间" align="center" prop="create_time" />
        </template>
    </ListPage>
</template>

<script>
import { list } from "@/api/promotion/list";
import { startDate, endDate } from "@/pages/config";
import listMixin from "@/mixins/list";
import { downloadFileByUrl } from "@/jslibs/utils";

export default {
    data() {
        return {
            list,
            // 查询参数
            query: {
                search_keyword: "",
                date: [],
            },
            pick: true,
        };
    },
    mixins: [listMixin],
    mounted() {
        this.search();
    },
    methods: {
        search() {
            const params = {
                ...this.query,
                search_start_time: this.query.date && this.query.date[0] ? startDate(0, this.query.date[0]) : null,
                search_end_time: this.query.date && this.query.date[1] ? endDate(0, this.query.date[1]) : null,
            };
            delete params.date;
            this._search(params);
        },
        handleSelectionChange(val) {
            this.ids = val.map((x) => x.uuid);
            this.names = val;
            this.ids_d = this.tableData.filter((x) => this.ids.indexOf(x.uuid) === -1).map((x) => x.uuid);
            this.merge();
        },
        async handleExport() {
            const filename = "推广列表.xlsx";
            const { search_keyword } = this.query;
            const [search_start_time, search_end_time] = this.query.date;
            const uuids = this.picks.map(x => x.uuid).join();
            downloadFileByUrl(
                process.env.VUE_APP_BASE_URL +
                `/v1/cms/user/promotion_list?export=1&search_user_role=1&search_keyword=${search_keyword}&search_start_time=${search_start_time || ""
                }&search_end_time=${search_end_time || ""}&uuids=${uuids}`,
                filename
            );
        },
    },
};
</script>
